import React, { useState, useRef } from 'react'
import useOnClickOutside from 'use-onclickoutside'
import useIsHovered from 'Simple/hooks/useIsHovered.js'
import { useFloating, offset, flip } from '@floating-ui/react-dom'

import View from './view.js'

export default function Logic(props) {
  let [hovered, , hoverBind] = useIsHovered({
    isDisabled: props.disabled,
    isSelected: false,
  })
  let [isOpen, setIsOpen] = useState(false)

  let triggerRef = useRef()

  let { refs, x, y, elements } = useFloating({
    open: props.isShowingDatePicker,
    placement: 'bottom-start',
    strategy: 'fixed',
    middleware: [
      flip(),
      offset({
        mainAxis: props.size !== 'small' ? 5 : 12,
      }),
    ],
  })

  useOnClickOutside(refs.floating, event => {
    if (
      event.target === triggerRef.current ||
      triggerRef.current?.contains(event.target)
    ) {
      return
    }

    setIsOpen(false)
  })

  return (
    <View
      {...props}
      hovered={hovered}
      onMouseEnter={hoverBind.onMouseEnter}
      onMouseLeave={hoverBind.onMouseLeave}
      isOpen={isOpen}
      onClick={onClick}
      triggerRef={triggerRef}
      parentRef={refs.setReference}
      contentRef={refs.setFloating}
      left={x}
      top={props.size === 'small' ? y - 10 : y}
      width={props.width ?? elements.reference?.getBoundingClientRect()?.width}
    />
  )

  function onClick(event) {
    if (props.disabled) return

    setIsOpen(!isOpen)
  }
}
